import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "show-more-dropdown",
  ref: "dropdown"
}
const _hoisted_2 = {
  "aria-role": "listitem",
  class: "show-more-dropdown-item"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Edit", -1)
const _hoisted_4 = {
  "aria-role": "listitem",
  class: "show-more-dropdown-item"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Delete", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrButton = _resolveComponent("NrButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NrIconButton, {
      class: "show-more-ellipsis",
      size: "small",
      variant: "minimal-primary",
      ref: "trigger",
      "aria-label": "Show more line item actions",
      icon: { name: 'ellipsis-v' }
    }, null, 512),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_NrButton, {
          size: "small",
          variant: "minimal-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-edit')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NrIcon, { name: "pencil-alt" }),
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NrButton, {
          size: "small",
          variant: "minimal-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-delete')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NrIcon, { name: "trash-alt" }),
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, $data.show]
    ])
  ], 64))
}